export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7163.d3191855.jpg";